import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/data";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1">
      <Link to={`/category/${comic.categoryId}`} className="block" aria-label={`查看${comic.title}`}>
        <div className="relative h-64 w-full overflow-hidden sm:h-56">
          <img
            src={comic.cover}
            alt={`${comic.title}漫画封面`}
            title={`${comic.title}漫画封面`}
            loading="lazy"
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-50">
            {comic.status}
          </span>
          <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
            <i className="ri-star-fill text-[11px]" aria-hidden="true"></i>
            {comic.rating}
          </span>
        </div>
        <div className="p-4">
          <h3 className="truncate font-heading text-base font-bold text-foreground-900 group-hover:text-primary-700">
            {comic.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-500">作者：{comic.author} · {comic.chapters}话</p>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {comic.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </article>
  );
}